import * as betgalaxy from './Group.styles.betgalaxy';
import * as betprofessor from './Group.styles.betprofessor';
import * as betroyale from './Group.styles.betroyale';
import * as goldenrush from './Group.styles.goldenrush';
import * as juicybet from './Group.styles.juicybet';
import * as puntcity from './Group.styles.puntcity';
import * as puntgenie from './Group.styles.puntgenie';
import * as questbet from './Group.styles.questbet';
import * as sterlingparker from './Group.styles.sterlingparker';
import * as vikingbet from './Group.styles.vikingbet';
import * as volcanobet from './Group.styles.volcanobet';
import * as wellbet from './Group.styles.wellbet';
import * as forsport from './Group.styles.forsport';
import * as fiestabet from './Group.styles.fiestabet';
import * as junglebet from './Group.styles.junglebet';
import * as oldgill from './Group.styles.oldgill';
import * as sugarcastle from './Group.styles.sugarcastle';
import * as buffalobet from './Group.styles.buffalobet';
import * as titanbet from './Group.styles.titanbet';
import * as templebet from './Group.styles.templebet';
import * as slambet from './Group.styles.slambet';
import * as gigabet from './Group.styles.gigabet';
import * as betstride from './Group.styles.betstride';
import * as goldenbet888 from './Group.styles.goldenbet888';
import * as hyperbet from './Group.styles.hyperbet';
import * as bet777 from './Group.styles.bet777';
import * as chromabet from './Group.styles.chromabet';
import * as bet575 from './Group.styles.bet575';
import * as betblast from './Group.styles.betblast';
import * as pyramidbet from './Group.styles.pyramidbet';
import * as magnumbet from './Group.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  fiestabet,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  templebet,
  slambet,
  gigabet,
  betstride,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
